import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { Stack } from "@mui-wrapper";

/** Skeleton loading for the settings integration */
export function IntegrationSettingsSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      flexDirection: "row",
      alignItems: "center",
      paddingX: "1.25rem",
      justifyContent: "space-between",
      width: "100%",
      gap: "1rem",
      marginY: "1.75rem"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexDirection: "row",
      gap: "1.875rem",
      alignItems: "center",
      width: "100%"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton variant="rectangular" sx={{
      width: "2.5rem",
      height: "2.5rem"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Stack sx={t1}>{t2}<Stack sx={{
        width: "100%"
      }}><Skeleton variant="text" width="20%" /><Skeleton variant="text" width="50%" /></Stack></Stack>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Stack sx={t0}>{t3}<Skeleton variant="rectangular" sx={{
        width: "10%",
        height: "1.25rem"
      }} /></Stack>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}